import { createContext, useContext, useState } from "react";

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [activeLang, setActiveLang] = useState("pt");

  return (
    <LangContext.Provider value={{ activeLang, setActiveLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
